import styled, { keyframes } from 'styled-components'

import { atMd, fromLg, untilMd } from '@syconium/little-miss-figgy'

export const ItemWrapper = styled.div`
  position: relative;
  margin-top: 24px;
  margin-left: 32px;
  cursor: pointer;
`

export const ItemTitle = styled.div<{
  isActive?: boolean
}>`
  font-size: ${o => (o.isActive ? '18px' : '14px')};
  transition: all 0.3s ease-in-out;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.7px;
  cursor: pointer;

  ${untilMd} {
    font-size: 18px;
    display: flex;
    justify-content: center;
    margin-top: -20px;
  }
`

export const PopUpWrapperAnimation = keyframes`
  0% {
    opacity: 0;
    height: 0;
  }

  1% {
    opacity: 0;
    height: 0;
  }
  100% {
    opacity: 1;
    height: auto;
  }
`

export const PopUpWrapperAnimationOut = keyframes`
  0% {
    opacity: 1;
    height: auto;
  }
  100% {
    opacity: 0;
    height: 0;
  }
`

export const ItemSubTitle = styled.div<{
  isActive?: boolean
}>`
  animation: ${o => (o.isActive ? PopUpWrapperAnimation : PopUpWrapperAnimationOut)} 0.3s
    ease-in-out;
  opacity: ${o => (o.isActive ? 1 : 0)};
  height: ${o => (o.isActive ? 'auto' : 0)};
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.8px;
  overflow-y: hidden;
  margin-top: 4px;

  ${fromLg} {
    max-width: 303px;
  }

  ${atMd} {
    max-width: 303px;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.7px;
  }

  ${untilMd} {
    font-size: 14px;
    text-align: center;
    opacity: 1;
    padding-bottom: 68px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const ItemIndicator = styled.div<{
  isActive?: boolean
  itPassed?: boolean
}>`
  width: ${o => (o.isActive || o.itPassed ? '11px' : '7px')};
  height: ${o => (o.isActive || o.itPassed ? '11px' : '7px')};
  background: ${o => (o.itPassed ? '#FFF' : '#000')};
  border: 1px solid;
  border-color: ${o => (o.itPassed ? '#cccccc' : '#000')};
  position: absolute;
  left: ${o => (o.isActive || o.itPassed ? '-39.5px' : '-37.5px')};
  top: ${o => (o.isActive || o.itPassed ? '4px' : '6px')};
  border-radius: 100%;
  transition: all 0.3s ease-in-out;
`
